import { AxiosResponse } from 'axios';
import { transferCreate, transferDelete, transferList, transferUpdate } from '@/api/transfer';
import { AppError } from '@/errors/appError';
import type { TransferItem } from '@/models/transfer';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types';
import { ITransferApiListResponse, ITransferFilters, ITransferMutationResponse, ITransferUpdateParams } from '@/types/transfer';

export const transferService = {
    async list(params: IListParams<ITransferFilters>): Promise<AxiosResponse<ITransferApiListResponse>> {
        try {
            return await baseListService<ITransferApiListResponse>(transferList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Transfer API Error:', e);
            throw new AppError('Unable to load transfer list, request error', { cause: e });
        }
    },

    async save(item: TransferItem): Promise<AxiosResponse<ITransferMutationResponse>> {
        const row = item.toApiData();
        if (item.id > 0) {
            return this.update({ rows: [row] });
        }
        return this.create({ rows: [row] });
    },

    async create(params: ITransferUpdateParams): Promise<AxiosResponse<ITransferMutationResponse>> {
        try {
            return await transferCreate(params);
        } catch (e) {
            console.error('Transfer create API Error:', e);
            throw new AppError('Unable to create transfer, request error', { cause: e });
        }
    },

    async update(params: ITransferUpdateParams): Promise<AxiosResponse<ITransferMutationResponse>> {
        try {
            return await transferUpdate(params);
        } catch (e) {
            console.error('Transfer update API Error:', e);
            throw new AppError('Unable to update transfer, request error', { cause: e });
        }
    },

    async delete(id: number): Promise<AxiosResponse<ITransferMutationResponse>> {
        try {
            return await transferDelete({ rows: [{ id }] });
        } catch (e) {
            console.error('Transfer delete API Error:', e);
            throw new AppError('Unable to delete transfer, request error', { cause: e });
        }
    },
};
